import { render } from "./Register.vue?vue&type=template&id=78649bc4&scoped=true&ts=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=78649bc4&lang=less&scoped=true"

import exportComponent from "E:\\project\\ale\\建大车辆入校预约\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78649bc4"]])

export default __exports__